import { Spinner } from "@/components/Spinner";

export function PageSpinner() {
  return (
    <div className="min-h-dvh flex items-center justify-center">
      <Spinner className="size-10" />
    </div>
  );
}
